export enum DATASOURCE {
  ATTIVO = 'ATTIVO',
  GENERIC_XDR = 'GENERIC_XDR',
  OKTA = 'OKTA',
  SENTINEL_ONE = 'SENTINEL_ONE',
  VECTRA = 'VECTRA',
}

export enum FIELD_TYPE {
  ARRAY = 'array', // CSV of text
  BOOLEAN = 'boolean',
  DATA_SOURCE = 'dataSource',
  DATA_SOURCE_VENDOR = 'dataSourceVendor',
  DATE = 'date',
  DEVICE = 'device',
  DNS = 'dns',
  EMAIL = 'email',
  ENDPOINT = 'endpoint',
  ENDPOINT_NAME = 'endpointName',
  ENUM = 'enum',
  EVENT_CATEGORY = 'eventCategory',
  EVENT_DETAILS = 'eventDetails',
  EVENT_SOURCE = 'eventSource',
  EVENT_SUMMARY = 'eventSummary',
  EVENT_TARGET = 'eventTarget',
  EVENT_TYPE = 'eventType',
  FILE = 'file',
  HASH = 'hash',
  HOST = 'host',
  ID = 'id',
  IP_ADDRESS = 'ipAddress',
  LINK = 'link',
  LOG_MESSAGE = 'logMessage',
  LOG_SOURCE = 'logSource',
  LOGFILE = 'logfile',
  MODULE = 'module',
  NUMBER = 'numeric',
  PROCESS = 'process',
  PROCESS_GRAPH = 'processGraph',
  REGISTRY_KEY = 'registryKey',
  SEVERITY = 'severity',
  TASK = 'task',
  TEXT = 'text',
  TIMESTAMP = 'timestamp',
  URL = 'url',
  USER = 'user',
  VENDOR = 'vendor',
}

export type SchemaField = {
  type: FIELD_TYPE;
  id?: string;
  label?: string;
  description?: string;
  // Enum values (to be used for autocomplete)
  values?: string[];
  // Name of the Icomoon icon from `font-mgmt` package; map for an enum
  icon?: string | Record<string, string>;
  width?: number;
  // Additional fields needed to render this one
  relatedFields?: string[];
  // Additional fields needed to render this one by key
  relatedFieldsMap?: { [key: string]: string[] };
  // true for fields that aren't ingested and cannot be searched, false by default
  notSearchable?: boolean;
};

export type SchemaFields = Record<string, SchemaField>;

export type Schema = {
  dataSource: DATASOURCE;
  // ID for the data source as sent in the event
  dataSourceId: string;
  // Vendor for the data source as sent in the event
  dataSourceVendor: string;
  dataSourceLabel: string;
  // Map of fields supported by this schema
  fields: SchemaFields;
  // Field ID that serves as the primary classification for the data source
  categoryField?: string;
  // Field ID array of those that should be shown in the Summary Section in the Inspector Log based on the event category
  summaryFieldIdsByCategory?: { [key in string]: string[] };
  // Field ID array of those that should be shown in the Summary Section in the Inspector Log
  summaryFieldIds?: string[];
};
